import {AlertFillIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

import styles from './ErrorWithRetry.module.css'
import {clsx} from 'clsx'

export interface ErrorWithRetryProps {
  message: string
  retry: () => void
  className?: string
}

export function ErrorWithRetry({message, retry, className}: ErrorWithRetryProps) {
  return (
    <div className={clsx(styles.ErrorWithRetryContainer, className)}>
      <div>
        <Octicon icon={AlertFillIcon} className={clsx('mr-1', styles.errorAlertIcon)} />
        <span className={styles.errorMessage}>{message}</span>
      </div>
      <Link as="button" inline onClick={retry} className={styles.retryActionLink}>
        <span className={styles.retryActionLink}>Try again</span>
      </Link>
    </div>
  )
}
